import { RG_TYPE } from "@project-rouge/rg-core";
function getStairCoreCount(sequence) {
	let count = 0;
	for (let i = 0; i < sequence.length; i++) {
		const unit = sequence[i].unit;
		if (unit.type === RG_TYPE.Core && !unit.data.hasFireLift && !unit.data.hasNonFireLift) count++;
	}
	return count;
}
export { getStairCoreCount };

//# sourceMappingURL=index135.js.map